import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { ITrazabilidad } from "../interfaces";
import { formatDateWithTime } from "../utils";


export interface ModuloTrazabolidad {
  [key: string]: any;
}
export const useTableColumnsTrazabilidad = () => {

  const findNonNullKey = (obj: ModuloTrazabolidad): string | null => {

    const result: ModuloTrazabolidad = {};

    let keys: string[] = ['prospecto', 'preventa', 'preagendamiento', 'agendamiento', 'orden_trabajo', 'solicitud_desbloqueo', 'codigo_otp'];

    keys.forEach(key => {
      if (key in obj) {
        result[key] = obj[key];
      }
    });

    for (const [key, value] of Object.entries(result)) {
      if (value !== null) {
        return key.replace('_', ' ').toLocaleUpperCase();
      }
    }
    return 'N/A';
  };

  const columnBase = useMemo<MRT_ColumnDef<ITrazabilidad>[]>(
    () => [
      {
        accessorKey: 'user',
        header: 'Usuario',
        size: 150,
        Cell: ({ row }) => row.original.user.toLocaleUpperCase()
      },
      {
        accessorKey: 'tipo_empleado',
        header: 'Tipo Empleado',
        size: 150
      },
      {
        accessorKey: 'accion',
        header: 'accion',
        size: 150
      },
      {
        accessorKey: 'modulo',
        header: 'Modulo',
        size: 150,
        Cell: ({ row }) => (
          findNonNullKey(row.original)
        )
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'fecha acción',
        size: 150,
        Cell: ({ row }) => formatDateWithTime(row.original.fecha_creacion)
      },
    ],
    [],
  );

  return {
    columnBase
  }
}